<template>
  <div v-if="indicators.length" class="flex f-wrap gap-10">
    <div v-for="(item, key) in indicators" :key="key" class="flex gap-10">
        <VTooltip
          :class="item.className"
          :popupText="item.title"
          :showTip="!showTitle && !!item.title"
        >
          <svgicon
            :icon="item.icon"
            :class="item.svgClass"
            width="24px"
            height="24px"
          />
          <span v-if="showTitle">{{ item.title }}</span>
        </VTooltip>
        <span v-if="item.numbers">{{ item.numbers }}</span>
    </div>
  </div>
</template>

<script>
import VTooltip from '@/components/ui/VTooltip.vue'

export default {
  name: 'IndicatorIcons',
  components: { VTooltip },
  props: {
    indicators: {
      type: Array,
      default: () => []
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  }
}
</script>
